export const DEFAULT_PAGE_SIZE = 10;
export const COLOR_TOOLTIP = "#292e39"


export const DEFAULT_LIST_PAGINATION = {
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: '-date_created',
}
// Loading
export const LOADING_TEXT = '...Carregando Informações';

// Header
export const TEXT_BUTTON_HEADER_LIST = 'Listagem';
export const TEXT_BUTTON_HEADER_CREATE = 'Cadastrar';


export const defaultparamsExport = {
    size: 999999,
    page: 0,
    sort: 'created,desc',
    search: '',
}